import { GroupMember } from '../types';

export const getInitials = (firstName: string, lastName: string): string => {
  return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return 'Unknown';
  return new Date(dateString).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
};

export const getRoleBadge = (member: GroupMember) => {
  const { role_type } = member;
  
  // Check if member is group admin
  if (member.is_main_admin || role_type === 'admin') {
    return {
      text: 'GROUP ADMIN',
      style: {
        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        color: 'white'
      },
      title: 'Group Administrator'
    };
  }

  if (!role_type) {
    return {
      text: 'Unknown',
      style: {
        backgroundColor: 'var(--gray)',
        color: 'white'
      },
      title: 'Unknown role'
    };
  }

  const roleColors: Record<string, string> = {
    admin: 'var(--primary)',
    member: 'var(--secondary)'
  };
  
  return {
    text: role_type.charAt(0).toUpperCase() + role_type.slice(1),
    style: {
      backgroundColor: roleColors[role_type] || 'var(--gray)',
      color: 'white'
    },
    title: `Role: ${role_type}`
  };
};

export const getStatusClass = (status: string | undefined, isActive: boolean): string => {
  const statusValue = status || (isActive ? 'Active' : 'Inactive');
  const normalizedStatus = statusValue.toLowerCase();
  
  switch (normalizedStatus) {
    case 'active':
      return 'statusActive';
    case 'inactive':
      return 'statusInactive';
    case 'pending':
      return 'statusPending';
    default:
      return isActive ? 'statusActive' : 'statusInactive';
  }
};

